export function formatIssuePeriod(issue) {
  if (!issue) return '';

  const startMonth = issue.start_month || issue.month || '';
  const startYear = issue.start_year || issue.year || '';
  const endMonth = issue.end_month || issue.month || startMonth;
  const endYear = issue.end_year || issue.year || startYear;

  if (!startMonth && !startYear && !endMonth && !endYear) return '';

  if (startMonth === endMonth && String(startYear) === String(endYear)) {
    return `${startMonth} ${startYear}`.trim();
  }

  return `${startMonth} ${startYear} - ${endMonth} ${endYear}`.trim();
}
